import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-survey-list',
  templateUrl: './admin-survey-list.component.html',
  styleUrls: ['./admin-survey-list.component.css']
})
export class AdminSurveyListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
